module.exports = __webpack_public_path__ + "img/toyota_thumbnail.37fab800.png";